import { render, staticRenderFns } from "./SharedToken.vue?vue&type=template&id=27865f64&"
import script from "./SharedToken.vue?vue&type=script&lang=js&"
export * from "./SharedToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports